import { useLocation } from "react-router";

import { PropsWithChildren } from "react";
import CurrentIntervalWidget from "./CurrentIntervalWidget";
import CurrentPageWidget from "./CurrentPageWidget";

export function HeaderText({ children }: PropsWithChildren) {
  return (
    <span
      className="min-w-0 truncate text-[16px] font-semibold text-foreground"
      style={{ fontFamily: "var(--font-serif)" }}
    >
      {children}
    </span>
  );
}

/**
 * Left inset of the header's time button, chosen so the brand mark's centre
 * lands on the timeline's spine: 1px of the list's border, plus SPINE_X (24)
 * from `RecordsTimeline`, less the button's own px-2 and half the 20px mark.
 */
const BRAND_PL = 1 + 24 - 8 - 10;

/** The routes with no interval to name; there the mark stands on its own. */
function namesAnInterval(pathname: string) {
  return (
    pathname !== "/admin" &&
    pathname !== "/login" &&
    !pathname.startsWith("/record")
  );
}

/**
 * Two controls, one per sidebar: the time button on the left, the space on the
 * right.
 *
 * The header no longer says which page this is. Every page that has a title
 * worth reading now shows it in its own body — a collection names itself in
 * `RecordsBand`, above the records it heads — and repeating it here only put
 * the name somewhere it could not be acted on.
 */
export default function Header() {
  const location = useLocation();

  return (
    <header className="bg-card sticky top-0 z-50 border-b min-h-[55px]">
      <div
        className="h-full flex items-center justify-between py-2 pr-2 gap-2"
        style={{ paddingLeft: BRAND_PL }}
      >
        {/* Kept as a slot even when it renders nothing, so justify-between
            still holds the right-hand control to the edge. */}
        <div className="flex items-center min-w-0">
          <CurrentIntervalWidget
            showInterval={namesAnInterval(location.pathname)}
          />
        </div>
        <CurrentPageWidget />
      </div>
    </header>
  );
}
